import { useEffect, useState } from "react";
import axios from "axios";
import AdCreative from "./AdCreative";
import { Button } from "primereact/button";

function AdScreenV2({
    disableFullScreen,
    disableOnClick,
    height = '100vh',
    width = '100vw',
}) {
    const AD_STORAGE_PREFIX = 'AD_ID';

    const [isFullScreen, setIsFullScreen] = useState(false);

    const [t, setT] = useState(0);
    const [ad, setAd] = useState(null);

    function loadAds() {
        if (!isFullScreen) {
            return;
        }
        if (getAdKeysFromStorage().length >= 5) {
            return;
        }

        axios.get(
            process.env.REACT_APP_API_HOST + '/adserver/get-campaigns/',
            {
                headers: {
                    'Authorization': localStorage.getItem('device_token'),
                }
            }
        ).then(
            (response) => {
                response.data.map(
                    a => {
                        console.log('APPEND', a);
                        localStorage.setItem(
                            AD_STORAGE_PREFIX + Date.now(),
                            JSON.stringify(
                                {
                                    'id': a.id,
                                    'creative_url': a.creative_url,
                                    'creative_ext': a.creative_ext,
                                    'creative_max_seconds_to_display': a.creative_max_seconds_to_display,
                                    'creative_is_muted': a.creative_is_muted,
                                }
                            )
                        )
                    }
                );
            }
        ).catch(
            (error) => {

            }
        )
    }

    function renderAd() {
        if (!ad) {
            return <div>Loading</div>;
        }
        return <AdCreative
            creativeURL={ad.creative_url}
            creativeExt={ad.creative_ext}
            shouldAutoPlay={true}
            hideControls={true}
            isMuted={ad.creative_is_muted}
            height='100%'
            width='100%'
            objectFit='contain'
        />;
    }

    function postAdImpression(my_ad) {
        const token = localStorage.getItem('device_token');
        axios.post(
            process.env.REACT_APP_API_HOST + '/ad_impressions/',
            {
                campaign_id: my_ad.id,
                screen_time: my_ad.creative_max_seconds_to_display,
                token: token,
            },
        ).then(
            (response) => {

            }
        ).catch(
            (error) => {

            }
        )
    }

    function getAdKeysFromStorage() {
        const keys = Object.keys(localStorage);

        const ad_keys = keys.filter(
            k => k.startsWith(AD_STORAGE_PREFIX)
        );
        console.log('FILTERED', ad_keys);
        return ad_keys;
    }

    function selectAd() {
        const ad_keys_from_storage = getAdKeysFromStorage();
        if (ad_keys_from_storage.length <= 0) {
            setTimeout(
                () => {
                    setT(t + 1);
                },
                1000,
            );
            return;
        }
        const ad_key = ad_keys_from_storage[0];
        const ad = JSON.parse(localStorage.getItem(ad_key));
        setAd(ad);
        localStorage.removeItem(ad_key);
        const tm = ad.creative_max_seconds_to_display ?? 1
        setTimeout(
            () => {
                postAdImpression(ad);
                setT(t + 1);
            },
            1000 * tm,
        )
    }

    useEffect(
        () => {
            loadAds();
        },
        [t, ad]
    );

    useEffect(
        () => {
            selectAd();
        },
        [t],
    )

    if (!isFullScreen && !disableFullScreen) {
        return (
            <div>
                <div
                    className="standard-box3"
                    style={{ marginTop: '2em' }}
                >
                    <h2>
                        Start full screen in order to display ads.
                    </h2>
                </div>
                <div
                    className="standard-box3"
                >
                    <Button
                        security="success"
                        label='Start Full Screen'
                        onClick={
                            () => {
                                document.body.requestFullscreen();
                                setIsFullScreen(true);
                            }
                        }
                    />
                </div>
            </div>
        )
    }

    return (
        <div
            onClick={() => {
                if (disableOnClick) {
                    return;
                }

                document.body.requestFullscreen();
                setIsFullScreen(true);
            }}
            style={{
                display: 'flex',
                alignItems: 'center',
                height: height,
                width: width,
            }}
        >
            {renderAd()}
        </div>
    );
}

export default AdScreenV2;